import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AuditorRoutes = defineRoute({
    record: {
        route: {
            path: "/auditor",
            component: () => loadView(import("./AuditorTable.vue")),
        },
    },
    create: {
        route: {
            path: "/auditor/create",
            component: () => loadView(import("./AuditorCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/auditor/update/:id",
            component: () => loadView(import("./AuditorUpdate.vue")),
        },
        build(id: string) {
            return `/auditor/update/${id}`;
        },
    },
});
